module.exports = __webpack_public_path__ + "img/fastcharger-rejected-semipublic.be171c48.png";